export const DATE_PICKER_WIDTH = 335
